import { Avatar } from "@heroui/react";
import { useState } from "react";

/**
 * The disc beside the date line of a card: the organisation's logo when
 * Platea has one (src/data/logos.ts, chosen by the adapter from the source's
 * domain), its initials otherwise, drawn as the header draws the user's. The
 * logo is a plain <img>, not Avatar.Image: Radix renders that only once the
 * image has loaded, which never happens under jsdom, and a bundled asset has
 * nothing to wait for. A file that fails to load falls back to the initials.
 * The image is decorative: the chips already name the organisation.
 */
export function SourceAvatar({ logo, initials }: { logo?: string; initials: string }) {
  const [failed, setFailed] = useState<string | null>(null);
  const src = logo && logo !== failed ? logo : undefined;
  return (
    <Avatar className={`size-10 shrink-0${src ? " border border-slate-100 bg-white" : ""}`}>
      {src ? (
        <img
          src={src}
          alt=""
          aria-hidden
          data-slot="source-logo"
          draggable={false}
          loading="lazy"
          onError={() => setFailed(src)}
          className="size-full object-contain p-1.5"
        />
      ) : (
        <Avatar.Fallback className="bg-default text-xs font-medium text-accent-soft-foreground">{initials}</Avatar.Fallback>
      )}
    </Avatar>
  );
}
